import pt from '../../i18n/vee-validate/pt';
import en from '../../i18n/vee-validate/en';

import { configure } from 'vee-validate';
import { localize, setLocale } from '@vee-validate/i18n';
import setupVeeValidateRules from './rules';

export default defineNuxtPlugin(() => {
  setLocale('pt_BR');

  setupVeeValidateRules();

  configure({
    generateMessage: localize({
      en,
      pt_BR: pt, // Portuguese (Brazil)
      pt_PT: pt, // Portuguese (Portugal)
    }),
  });
});
